// extracted by mini-css-extract-plugin
export default {"contentHeader":"ResumeClaimSubmission_contentHeader__yDg7v","appleLogo":"ResumeClaimSubmission_appleLogo__C7kAM","resumeClaimSB":"ResumeClaimSubmission_resumeClaimSB__UvBqi"};